import { persist } from 'mobx-persist'
import { observable } from 'mobx'

export class SidebarState {
    @persist
    @observable
    public collapsed: boolean = false
}
